module.exports = __webpack_public_path__ + "img/tour-47.2122f82f.png";